/**
 * Toggle hamburger menu
 */
document.addEventListener('click', function (event) {

    if (!event.target.matches('.js-nav-icon') && !event.target.matches('.js-nav-icon span') && !event.target.matches('nav.mainmenu.open li a span')) return;
    // event.preventDefault();
    var icon = document.querySelector('.js-nav-icon');
    var menu = document.querySelector('.js-mainmenu');

    icon.classList.toggle('open');
    menu.classList.toggle('open');

}, false);

/**
 * Get the closest parent element with selector
 * @param elem
 * @param selector
 * @returns {*}
 */

function getClosest(elem, selector) {

    if (!Element.prototype.matches) {
        Element.prototype.matches =
            Element.prototype.matchesSelector ||
            Element.prototype.mozMatchesSelector ||
            Element.prototype.msMatchesSelector ||
            Element.prototype.oMatchesSelector ||
            Element.prototype.webkitMatchesSelector ||
            function (s) {
                var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                    i = matches.length;
                while (--i >= 0 && matches.item(i) !== this) {
                }
                return i > -1;
            };
    }

    // Get the closest matching element
    for (; elem && elem !== document; elem = elem.parentNode) {
        if (elem.matches(selector)) return elem;
    }
    return null;

};